import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paymentStatusEs',
  standalone: true,
})
export class PaymentStatusEsPipe implements PipeTransform {
  transform(status?: string | null): string {
    if (!status) return 'Desconocido';

    switch (status.toLowerCase()) {
      case 'paid':
        return 'Pagado';
      case 'pending':
        return 'Pendiente';
      case 'processing':
        return 'En proceso';
      case 'failed':
        return 'Fallido';
      case 'partially_paid':
        return 'Parcialmente pagado';
      case 'refunded':
        return 'Reembolsado';
      default:
        return status; // por si llega algo raro
    }
  }
}
